(function () {
  const initAnimation = (section) => {
    if (
      !section ||
      !section.classList.contains("ticker-banner-section")
    )
      return;
    const ticker = section.querySelector(".ticker-banner__ticker");
    if (!ticker) return;
    ScrollTrigger.create({
      trigger: ticker,
      start: "50% 100%",
      end: "bottom top",
      onEnter: () => ticker.classList.add("animated"),
    });
  };
  initAnimation(document.currentScript.parentElement);
  document.addEventListener("shopify:section:load", (e) => {
    initAnimation(e.target);
  });
})();
